'use client';

import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';

import { CustomLink } from '@/app/_components/CustomLink';

import { useNavigationGroupList } from '../../_hooks/useNavigationGroupList';

export const MyNavigation = () => {
  const { navigationGroupList } = useNavigationGroupList();
  const pathname = usePathname() ?? '';

  return (
    <nav>
      <ul className="flex flex-col gap-40">
        {navigationGroupList.map((group) => (
          <li key={group.label} className="flex flex-col gap-16">
            <p className="font-700 text-Gray-900 typo-body2">{group.label}</p>
            <ul className="flex flex-col gap-12">
              {group.items.map((item) => {
                const activePathname = item.activePathname ?? item.href;
                const isActive =
                  pathname === activePathname ||
                  pathname.startsWith(`${activePathname}/`);

                const content = (
                  <>
                    <p
                      className={cn('font-500 text-Gray-550 typo-body3', {
                        'text-Gray-900': isActive,
                      })}
                    >
                      {item.label}
                    </p>
                    {item.isNew ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <circle cx="7.99805" cy="8" r="8" fill="#F5511D" />
                        <path
                          d="M10.37 5V11H9.41L6.56 6.9H6.51V11H5.44V5H6.42L9.24 9.1H9.3V5H10.37Z"
                          fill="white"
                        />
                      </svg>
                    ) : null}
                  </>
                );

                return (
                  <li
                    key={item.label}
                    className="flex items-center justify-between pl-12"
                  >
                    {item.onClick ? (
                      <button
                        type="button"
                        aria-current={isActive ? 'page' : undefined}
                        className="relative flex w-fit items-center gap-4"
                        onClick={item.onClick}
                      >
                        {content}
                      </button>
                    ) : (
                      <CustomLink
                        aria-current={isActive ? 'page' : undefined}
                        className="relative flex w-fit items-center gap-4"
                        href={item.href}
                        aria-label={`${item.label} 페이지로 이동`}
                      >
                        {content}
                      </CustomLink>
                    )}
                  </li>
                );
              })}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  );
};
